<template>
  <div class="articleSelect">
    <el-dialog title="选择添加文章"
               @open='initializeData'
               :visible.sync="data.show"
               width="1000px"
               :before-close="handleClose">
      <div class="articleSelect_view">
        <el-checkbox-group v-model="selectedArticle"
                           :max="selectNum">
          <el-table :data="tableData"
                    style="width: 100%">
            <el-table-column width="55">
              <template slot-scope="scope">
                <el-checkbox :label="scope.row.id"
                             :disabled='(scope.row.tag&&scope.row.tag[tagid])||scope.row.tagid.length>=5?true:false'></el-checkbox>
              </template>
            </el-table-column>
            <el-table-column label="封面图片"
                             width="130">
              <template slot-scope="scope">
                <el-image style="width: 80px; height: 80px"
                          :src="scope.row.thumb"
                          :preview-src-list="[scope.row.thumb]"
                          fit="fit"></el-image>
              </template>
            </el-table-column>
            <el-table-column label="创建日期"
                             sortable
                             prop="createtime"
                             width="160">
              <template slot-scope="scope">
                {{common.formatDate(scope.row.createtime)}}
              </template>
            </el-table-column>
            <el-table-column prop="click"
                             sortable
                             label="阅读次数"
                             width="100">
            </el-table-column>

            <el-table-column prop="title"
                             label="文章标题"
                             show-overflow-tooltip
                             width="180">
            </el-table-column>
            <el-table-column prop="description"
                             show-overflow-tooltip
                             label="文章描述">
            </el-table-column>

          </el-table>
        </el-checkbox-group>
        <el-pagination background
                       :page-size='pageSize'
                       layout="prev, pager, next"
                       @current-change='tabPage'
                       :total="articleNum">
        </el-pagination>
      </div>
      <span slot="footer"
            class="dialog-footer">
        <el-button @click="data.show = false">取 消</el-button>
        <el-button type="primary"
                   @click="confirmSaveArticle">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { apiGetArticle, yxArticleTag } from '@/request/api'
import common from '@/assets/js/common'
export default {
  data () {
    return {
      // 选择的文章
      selectedArticle: [],

      // 文章总数量
      articleNum: 0,

      // 一页显示数量
      pageSize: 6,

      // 页码
      page: 1,

      // 公共方法
      common,

      // 表格数据
      tableData: []
    }
  },
  props: {
    data: {
      type: Object,
      default: () => {
        return { show: false }
      }
    },
    cid: {
      type: [Number, String],
    },
    selectNum: {
      type: [Number, String],
    },
    mid: {
      type: [Number, String]
    },
    tagid: {
      type: [Number, String]
    }

  },
  methods: {
    // ---------------------切换页码-------------
    async tabPage (e) {
      this.page = e
      let res = await this.getSelectArticle()
      this.tableData = res.article
      this.articleNum = parseInt(res.totalNum)
    },
    // ---------------------确定保存文章-------------
    confirmSaveArticle () {
      this.$confirm(`是否将${this.selectedArticle.length}篇文章添加到该栏目？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        let res = await yxArticleTag({
          siteid: this.mid,
          id: this.selectedArticle,
          tagid: this.tagid
        })
        this.$message(res.message)
        this.$emit('addEndFun', {})
        this.data.show = false
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消添加'
        });
      });
    },

    // ---------------------初始化数据-------------
    async initializeData () {
      this.page = 1
      this.selectedArticle = []
      let res = await this.getSelectArticle()
      this.tableData = res.article
      this.articleNum = parseInt(res.totalNum)
    },
    // ---------------------获取可选择的文章-------------
    async getSelectArticle () {
      let res = await apiGetArticle({
        siteid: this.mid,
        page: this.page,
        pageSize: this.pageSize
      })
      console.log(this.cid);
      if (res.errno != -1) {
        for (let i = 0; i < res.article.length; i++) {
          if (res.article[i].content == 'showNull') {
            res.article.splice(i--, 1);
          }
        }
      }
      return res
    },
    // ---------------------关闭确认-------------
    handleClose (done) {
      this.$confirm('确认关闭？')
        .then(_ => {
          done();
        })
        .catch(_ => { });
    },
  },

}
</script>

<style lang='scss'>
.articleSelect_view {
  width: 100%;
  min-height: 700px;
  .el-pagination {
    margin-top: 20px;
    display: flex;
    justify-content: center;
  }
  .el-checkbox__label {
    display: none;
  }
}
</style>